import React from "react";
import { FiCheckCircle, FiClock, FiEye, FiEyeOff } from "react-icons/fi";

export function ActiveBadge({ active }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold ${
        active
          ? "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300"
          : "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
      }`}
    >
      {active ? <FiCheckCircle /> : <FiClock />}
      {active ? "Actif" : "Inactif"}
    </span>
  );
}

export function PublicBadge({ isPublic }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold ${
        isPublic
          ? "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300"
          : "border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300"
      }`}
    >
      {isPublic ? <FiEye /> : <FiEyeOff />}
      {isPublic ? "Affiché" : "Masqué"}
    </span>
  );
}